Backbone = require 'backbone'

class SupportDropDownCombinationsModel extends Backbone.Model
  initialize: ->
    @url = "#{window.SUPPORTBASEURL}/fetch?key=dropdown_combinations_for_flex_step_three&type=dropdown_combinations_for_flex_step_three"

module.exports = SupportDropDownCombinationsModel
